export enum ParticipantTypeEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  PAIR = 'PAIR',
  TEAM = 'TEAM',
  GROUP = 'GROUP'
}
